import React, { useEffect, useState } from 'react'

import {
  handleCarouselClick,
  incrementNumber,
} from '../NewBanner/NewBannerHelpers'
import style from './MainBanner.module.scss'

const banners = [
  [
    {
      link: 'https://www.pik.ru/pages/newstarts?_ga=2.166429880.740301253.1734942760-1632254734.1726740708&utm_source=rbc',
      title: 'Квартиры с отделкой\nот 3,4 млн руб.',
      description:
        'Количество предложения ограничено. ПАО «ПИК СЗ». ОГРН 1027739137084. Юр. адрес: 123242, г. Москва, ул. Баррикадная, д. 19, стр. 1. Подробнее на pik.ru. Проектные декларации проектов на наш.дом.рф',
    },
  ],
  // [
  //   {
  //     link: 'https://www.pik.ru/sp?utm_source=rbc',
  //     title: 'Саларьево парк\nНовый корпус по стартовым ценам',
  //     description:
  //       'Реклама. Застройщик ООО СЗ «Тирон», 111024, г. Москва, ул. Душинская, д. 7, стр. 1, пом 4/420, ОГРН 1167746411799. Подробности на pik.ru. Проектная декларация на сайте наш.дом.рф',
  //   },
  //   {
  //     link: 'https://www.pik.ru/sp?utm_source=rbc',
  //     title: 'Саларьево парк\nУспейте до повышения цен',
  //     description:
  //       'Реклама. Застройщик ООО СЗ «Тирон», 111024, г. Москва, ул. Душинская, д. 7, стр. 1, пом 4/420, ОГРН 1167746411799. Подробности на pik.ru. Проектная декларация на сайте наш.дом.рф',
  //   },
  // ],
  // [
  //   {
  //     link: 'https://www.pik.ru/yauza?utm_source=rbc',
  //     title: 'Яуза парк\nЗабронируйте на старте продаж',
  //     description:
  //       'ООО СЗ «НМ-Консалт». 140054, Московская область, г. Котельники, Яничкин проезд 2, помещение 21. ОГРН 1197746701877. Подробности на pik.ru. Проектная декларация на сайте наш.дом.рф',
  //   },
  // ],
  // [
  //   {
  //     link: 'https://www.pik.ru/il-luga?utm_source=rbc',
  //     title: 'Ильинские луга\nЗабронируйте на старте продаж',
  //     description:
  //       'Застройщик ООО «СЗ «ГРАДОЛИМП», адрес: 141021, МО, г. Мытищи, ул. Борисовка, дом 4, пом. Х, комната 21, ОГРН: 1137746339720. Подробности на pik.ru. Проектная декларация на сайте наш.дом.рф.',
  //   },
  // ],
]

function MainBanner({
  place,
  id,
  pageType,
}: {
  place: string | undefined
  id: string | undefined
  pageType: string
}) {
  const [currentBanner, setCurrentBanner] = useState<number>(0)
  const [currentIndex, setCurrentIndex] = useState(0)
  const [bannerData, setBannerData] = useState(banners[currentBanner])

  useEffect(() => {
    incrementNumber(banners)
    const bannerIndex = localStorage.getItem('bannerIndex')
    setCurrentBanner(() => {
      const index = bannerIndex !== null ? +bannerIndex : 0
      setBannerData(banners[index])

      return index
    })
  }, [])

  useEffect(() => {
    if (bannerData.length === 0) return

    const interval = setInterval(() => {
      setCurrentIndex(prevIndex => (prevIndex + 1) % bannerData.length)
    }, 3000)

    return () => clearInterval(interval) // Очистка интервала при размонтировании компонента
  }, [bannerData.length])

  return (
    <a
      href={bannerData[currentIndex].link}
      target='_blank'
      className={style.banners}
      onClick={() => {
        handleCarouselClick(bannerData[currentIndex].title, id, pageType, place)
      }}
    >
      {bannerData.map((banner, index) => (
        <div
          key={index}
          className={style.banner}
          style={{ display: index === currentIndex ? 'block' : 'none' }} // Показываем только текущий баннер
        >
          <div className={style.banner__wrapper}>
            <span>
              {banner.title.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </span>
            <p>
              {banner.description.split('\n').map((line, i) => (
                <React.Fragment key={i}>
                  {line}
                  <br />
                </React.Fragment>
              ))}
            </p>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='96'
              height='172'
              viewBox='0 0 96 172'
              fill='none'
            >
              <path
                d='M96 72.9785L53.6168 81.5105L78.4376 0L0 93.8712L38.9617 86.7191L3.00618 172L96 72.9785Z'
                fill='white'
              />
            </svg>
          </div>
        </div>
      ))}
    </a>
  )
}

export default MainBanner
